import { eventBus } from './eventBus';

const MODAL_EVENTS = {
  SHOW: 'modal:show',
  HIDE: 'modal:hide',
  ACTION: 'modal:action'
};

const ModalUtils = {
  showModal(title, message, actions = [], loading = false, options = {}) {
    eventBus.emit(MODAL_EVENTS.SHOW, {
      title,
      message,
      actions,
      loading,
      options,
      modalId: `modal-${Date.now()}-${Math.floor(Math.random() * 1000)}`
    });
  },

  hideModal() {
    eventBus.emit(MODAL_EVENTS.HIDE);
  }
};

export { MODAL_EVENTS };
export default ModalUtils;